/* eslint-disable @typescript-eslint/no-unused-vars */
import { createSlice } from '@reduxjs/toolkit';
import {
  AffiliationUsersListState,
  AffiliationUsersListFetchAction,
  AffiliationUsersListFetchSuccessAction,
  AddMemberAction,
  EditMemberAction,
} from './affiliationUsersList.types';
import { createSliceHook, makeActionCreator } from '../helpers';

const initialState: AffiliationUsersListState = {
  loading: false,
  error: undefined,
  data: [],
  totalUsers: 0,
  addMember: null,
  editMember: null,
};

const { actReq, act, actReject } =
  makeActionCreator<AffiliationUsersListState>();

export const affiliationUsersListSlice = createSlice({
  name: 'affiliationUsersList',
  initialState,
  reducers: {
    fetchAffiliationUsersList:
      actReq<AffiliationUsersListFetchAction['payload']>(),
    fetchAffiliationUsersListSuccess: act<
      AffiliationUsersListFetchSuccessAction['payload']
    >((data, state) => ({
      data,
      totalUsers: state.totalUsers === 0 ? data.length : state.totalUsers,
      loading: false,
      error: undefined,
    })),
    fetchAffiliationUsersListFailure: actReject<Error>(),

    addMemberRequest: act<AddMemberAction['payload']>((data, state) => ({
      addMember: 'LOADING',
    })),
    addMemberSuccess: act<null>((data, state) => ({
      addMember: 'SUCCESS',
    })),
    addMemberFailure: act<null>((data, state) => ({
      addMember: 'FAILURE',
    })),

    editMemberRequest: act<EditMemberAction['payload']>((data, state) => ({
      editMember: 'LOADING',
    })),
    editMemberSuccess: act<null>((data, state) => ({
      editMember: 'SUCCESS',
    })),
    editMemberFailure: act<null>((data, state) => ({
      editMember: 'FAILURE',
    })),
  },
});

export const {
  fetchAffiliationUsersList,
  fetchAffiliationUsersListSuccess,
  fetchAffiliationUsersListFailure,
} = affiliationUsersListSlice.actions;

export const actions = {
  ...affiliationUsersListSlice.actions,
};

export const useAffiliationUsersListSlice = createSliceHook(
  affiliationUsersListSlice.name,
  actions
);
